import { jsxs as t, Fragment as x, jsx as r } from "react/jsx-runtime";
import { CurrencyBadge as a } from "../../../../../ui-kit/currency-badge.mjs";
import { getAmountWithCurrencySymbol as i } from "../../../../../utils/get-amount-with-currency-symbol.mjs";
import { useLocaleContext as f } from "../../../../../providers/use-locale-provider.mjs";
import { usePhysicalProductStore as p } from "../../../../../store/index.mjs";
import { getProductPriceWithQuantity as d } from "../../utils/get-product-price-with-quantity.mjs";
import { useTranslation as h, centsToUnits as o } from "@systemeio/ui";
const w = ({ product: e, calculatePrice: n }) => {
  const { locale: s } = f(), { quantity: m, productVariant: c } = p(), { t: l } = h();
  return e && e.name && /* @__PURE__ */ t(x, { children: [
    /* @__PURE__ */ t("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ t("div", { className: "flex gap-1 text-[14px]", children: [
        /* @__PURE__ */ r("span", { children: e.name }),
        /* @__PURE__ */ t("span", { className: "font-bold", children: [
          "x",
          m
        ] })
      ] }),
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ r(a, { currency: e.currency }),
        /* @__PURE__ */ r("span", { className: "text-[14px] font-semibold", children: i(
          o(
            d({
              calculatePrice: n,
              productVariant: c,
              product: e,
              quantity: m
            })
          ),
          e.currency,
          s
        ) })
      ] })
    ] }),
    !!(n != null && n.tax) && n.tax.rate > 0 && /* @__PURE__ */ t("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ r("span", { className: "text-[14px]", children: l("public_pages_purchase.vat_percent", {
        percent: n.tax.rate
      }) }),
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ r(a, { currency: e.currency }),
        /* @__PURE__ */ r("span", { className: "text-[14px] font-semibold", children: i(
          o(n.tax.amount),
          e.currency,
          s
        ) })
      ] })
    ] })
  ] });
};
export {
  w as Product
};
